import { gql } from "graphql-tag";
import React from "react";
import { useMutation } from "@apollo/client";
import { newOrg } from "types/gql-types";
import { AdminHeading } from "../shared/admin-form";
import { useAdminSubmit } from "../shared/use-admin-submit";
import OrganizationForm, { OrgForm } from "./form";

const CREATE_ORG = gql`
  mutation newOrg($data: OrganizationInput!) {
    createOrganization(data: $data) {
      id
      name
    }
  }
`;

// defaulting type to property per discussion with adam
const initialData = {
  name: "",
  type: "property",
  email: "",
  bccEmail: "",
  phone: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
};


const NewOrganization: React.FC = () => {
  const { sending, submit } = useAdminSubmit("/dash/admin/organizations");
  const [createOrgFunc] = useMutation<newOrg>(CREATE_ORG);
  const submitForm = (formData: OrgForm) =>
    submit(() => createOrgFunc({ variables: { data: formData } }));
  return (
    <div>
      <AdminHeading>Create an Organization</AdminHeading>
      <OrganizationForm
        formType="new"
        initialData={initialData}
        sending={sending}
        handleSubmit={submitForm}
      />
    </div>);

};

export default NewOrganization;
